import React from 'react';

/**
 * Day 4 — Low-risk observational tags.
 *
 * Deterministic, non-diagnostic pills derived from the 7-day bowel window.
 * Fails safe: renders nothing when tags array is empty/missing.
 */

const TAG_STYLE = {
  'Hard stool pattern observed': 'bg-amber-50 border-amber-300 text-amber-800',
  'Loose stool pattern observed': 'bg-sky-50 border-sky-300 text-sky-800',
  'Pain/discomfort recorded recently': 'bg-rose-50 border-rose-300 text-rose-700',
  'Frequent no bowel action recorded': 'bg-rose-50 border-rose-300 text-rose-700',
  'No recent entries': 'bg-slate-100 border-slate-300 text-slate-700',
};

export function BowelObservationTags({ tags }) {
  if (!Array.isArray(tags) || tags.length === 0) return null;
  return (
    <div className="flex items-center flex-wrap gap-1.5" data-testid="bowel-observation-tags">
      {tags.map((t, i) => (
        <span
          key={i}
          data-testid={`bowel-obs-tag-${i}`}
          className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${TAG_STYLE[t] || 'bg-slate-100 border-slate-300 text-slate-700'}`}
        >
          {t}
        </span>
      ))}
    </div>
  );
}

export default BowelObservationTags;
